import { Typography } from 'antd';
import styled from 'styled-components';
import { APP_SHELL_THEME } from '@/styles/appShellTheme';

export const ConfirmModalTitle = styled(Typography.Title)`
  &.ant-typography {
    font-weight: 600;
    font-size: 20px;
    margin: 0 !important;
    font-family: 'Inter', sans-serif;
    color: rgba(${APP_SHELL_THEME.overlayRgb}, 0.92) !important;
    line-height: 1.3;
  }
`;
